import { render, staticRenderFns } from "./CorporateStylePage.vue?vue&type=template&id=e36111e0"
import script from "./CorporateStylePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateStylePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports